define('Store.Profile.Service.Model', [
    'Backbone.Model',
    'Utils',
    'underscore'
], function StoreProfileModel(
    BackboneModel,
    Utils,
    _
) {
    'use strict';

    return BackboneModel.extend({
        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Store.Profile.Service.ss'))
    });
});
